import {FormControl, OutlinedInput} from '@mui/material';
import {ChangeEventHandler, MutableRefObject, ReactNode} from 'react';

interface IProps {
	placeholder?: string;
	inputRef?: MutableRefObject<HTMLInputElement | undefined>;
	value?: string;
	onChange?: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
	endAdornment?: ReactNode;
	className?: string;
	disabled?: boolean;
	defaultValue?: string;
}

export default function InputRez({
	                                 placeholder,
	                                 inputRef,
	                                 value,
	                                 onChange,
	                                 endAdornment,
	                                 className,
	                                 disabled,
	                                 defaultValue
                                 }: IProps) {
	return (
		<FormControl disabled={disabled} className={className} fullWidth variant="outlined">
			<OutlinedInput
				defaultValue={defaultValue}
				value={value}
				inputRef={inputRef}
				sx={{bgcolor: 'grey.50', borderColor: 'grey.100'}}
				size="small"
				placeholder={placeholder}
				onChange={onChange}
				endAdornment={endAdornment}
			/>
		</FormControl>
	);
}
